module.exports = __webpack_public_path__ + "static/img/des9-bg3.387bbec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/des9-bg3.png
// module id = XXWz
// module chunks = 0